/**
 * Recorta a imagem no centro (cover), redimensiona e devolve PNG em base64.
 *
 * Serve pro favicon: o arquivo publicado se chama favicon.png, entao precisa
 * SER png de verdade (um jpeg renomeado quebra em parte dos navegadores) e
 * quadrado (favicon esticado fica torto).
 */
export const toSquarePngBase64 = (file, size = 128, padding = 0.12) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('read_failed'));
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error('decode_failed'));
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext('2d');
        // recorte central: pega o maior quadrado que cabe na imagem
        const side = Math.min(img.width, img.height);
        const sx = (img.width - side) / 2;
        const sy = (img.height - side) / 2;
        // respiro: margem transparente em volta — colado na borda o icone
        // sai "cortado" na aba do navegador
        const pad = Math.round(size * padding);
        const inner = size - pad * 2;
        ctx.drawImage(img, sx, sy, side, side, pad, pad, inner, inner);
        resolve(canvas.toDataURL('image/png').split(',')[1]);
      };
      img.src = String(reader.result);
    };
    reader.readAsDataURL(file);
  });
